import IMessage from '../IMessage';

export enum SyncMessageType {
	BroadcastedValue = 'set_value',
	Status = 'device_status',
	Closed = 'closed',
}

export interface BroadcastedValueMessage extends IMessage {
	groupName: string;
	key: string;
	value: any;
}

export interface StatusMessage extends IMessage {
	connectedPeers: string[];
	groupName?: string;
	isMaster?: boolean;
}

export interface ClosedMessage extends IMessage {
	error?: string;
}
